export class BackupZeroEtlColumnDefinition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sourceColumn",
            "baseName": "sourceColumn",
            "type": "string",
            "format": ""
        },
        {
            "name": "extract",
            "baseName": "extract",
            "type": "BackupZeroEtlColumnExtract",
            "format": ""
        },
        {
            "name": "castType",
            "baseName": "castType",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlColumnDefinition.attributeTypeMap;
    }
    constructor() {
    }
}
